export default "__VITE_ASSET__CoVC3Zwo__"